import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Claim 1 Bill")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Course Type", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-4" }, "Bill Information", -1)
const _hoisted_13 = { class: "card mb-5 mb-xl-10 mt-2" }
const _hoisted_14 = {
  id: "bill_info",
  class: "collapse show"
}
const _hoisted_15 = { class: "collapse show" }
const _hoisted_16 = { class: "card-body border-top p-9" }
const _hoisted_17 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-md-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = { class: "col-md-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_24 = { class: "col-md-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Contract", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Claim"),
  /*#__PURE__*/_createElementVNode("input", {
    type: "number",
    class: "form-control",
    value: 1,
    disabled: ""
  })
], -1)
const _hoisted_27 = { class: "col-md-3 mt-3" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Bill Sequence No", -1)
const _hoisted_29 = { class: "col-md-3 mt-3" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Bill Date", -1)
const _hoisted_31 = { class: "mt-4" }
const _hoisted_32 = { class: "card mb-5 mb-xl-10 mt-2" }
const _hoisted_33 = {
  id: "bill_info",
  class: "collapse show"
}
const _hoisted_34 = { class: "collapse show" }
const _hoisted_35 = { class: "card-body border-top p-9" }
const _hoisted_36 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_37 = { class: "table-responsive mt-5" }
const _hoisted_38 = { class: "table table-borderless gy-4" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-black" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Action"),
    /*#__PURE__*/_createElementVNode("th", null, "Sl"),
    /*#__PURE__*/_createElementVNode("th", null, "Training Institutes"),
    /*#__PURE__*/_createElementVNode("th", null, "Course"),
    /*#__PURE__*/_createElementVNode("th", null, "Batch No"),
    /*#__PURE__*/_createElementVNode("th", null, "Enroll Trainee")
  ])
], -1)
const _hoisted_40 = { style: {} }
const _hoisted_41 = { class: "align-middle" }
const _hoisted_42 = ["value"]
const _hoisted_43 = { class: "align-middle" }
const _hoisted_44 = { class: "align-middle" }
const _hoisted_45 = { class: "align-middle" }
const _hoisted_46 = { class: "align-middle" }
const _hoisted_47 = { class: "align-middle" }
const _hoisted_48 = ["data-kt-indicator"]
const _hoisted_49 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_50 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_51 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_53 = { class: "mt-4" }
const _hoisted_54 = { class: "card mb-5 mb-xl-10" }
const _hoisted_55 = {
  id: "assessor_data",
  class: "collapse show"
}
const _hoisted_56 = { class: "collapse show" }
const _hoisted_57 = { class: "card-body border-top p-6" }
const _hoisted_58 = { class: "table-responsive mt-5" }
const _hoisted_59 = { class: "table table-borderless gy-4" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-black" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Action"),
    /*#__PURE__*/_createElementVNode("th", null, "Sl"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"180px"} }, "Training Institutes"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"180px"} }, "Course"),
    /*#__PURE__*/_createElementVNode("th", null, "BN"),
    /*#__PURE__*/_createElementVNode("th", null, "Trainee Count"),
    /*#__PURE__*/_createElementVNode("th", null, "Unit Cost"),
    /*#__PURE__*/_createElementVNode("th", null, "Pay %"),
    /*#__PURE__*/_createElementVNode("th", null, "Payment Amount"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"120px"} }, "Bill Amount"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"120px"} }, "Bill No"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"120px"} }, "Bill Date")
  ])
], -1)
const _hoisted_61 = { style: {} }
const _hoisted_62 = { class: "align-middle" }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-trash-alt" }, null, -1)
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = { class: "align-middle" }
const _hoisted_67 = { class: "align-middle" }
const _hoisted_68 = { class: "align-middle" }
const _hoisted_69 = { class: "align-middle" }
const _hoisted_70 = { class: "align-middle" }
const _hoisted_71 = { class: "align-middle" }
const _hoisted_72 = { class: "align-middle" }
const _hoisted_73 = { class: "align-middle" }
const _hoisted_74 = { class: "align-middle" }
const _hoisted_75 = { class: "align-middle" }
const _hoisted_76 = { class: "align-middle" }
const _hoisted_77 = { style: {"border-bottom":"1px solid rgba(29, 182, 140, 0.51) !important"} }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("th", { class: "font-weight-bold text-black" }, "Total", -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_82 = { class: "font-weight-bold text-black" }
const _hoisted_83 = { class: "font-weight-bold text-black" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_87 = { class: "font-weight-bold text-black" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_90 = { style: {"border-bottom":"1px solid rgba(29, 182, 140, 0.51) !important"} }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "9",
  class: "font-weight-bold text-black text-end"
}, " A) Gross Amount ", -1)
const _hoisted_92 = { class: "font-weight-bold text-black" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_95 = { style: {"border-bottom":"1px solid rgba(29, 182, 140, 0.51) !important"} }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "9",
  class: "font-weight-bold text-black text-end"
}, " B) IA'S Contribution ", -1)
const _hoisted_97 = { class: "font-weight-bold text-black" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_99 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_100 = { style: {"border-bottom":"1px solid rgba(29, 182, 140, 0.51) !important"} }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "9",
  class: "font-weight-bold text-black text-end"
}, " C) Contribution Amount (A*B) ", -1)
const _hoisted_102 = { class: "font-weight-bold text-black" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_105 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "9",
  class: "font-weight-bold text-black text-end"
}, " D) Net Payable (A - C) ", -1)
const _hoisted_106 = { class: "font-weight-bold text-black" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_108 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_109 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-info p-3",
  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
}, " Bill Attachments ", -1)
const _hoisted_110 = ["data-kt-indicator"]
const _hoisted_111 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_112 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_113 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_114 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Course Type",
                  modelValue: _ctx.bill.course_type,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bill.course_type) = $event)),
                  filterable: "",
                  style: {"width":"100%"},
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.billListShow()))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseTypes, (types) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: types.id,
                        label: types.type_name,
                        value: types.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(types.type_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ])
          ]),
          (_ctx.showBillInfo == true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _hoisted_20,
                              _hoisted_21,
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select Tranche",
                                modelValue: _ctx.bill.tranche_id,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bill.tranche_id) = $event)),
                                style: {"width":"100%"},
                                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getAssociation()))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches, (trans) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: trans.id,
                                      label: trans.label,
                                      value: trans.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(trans.label), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_22, [
                              _hoisted_23,
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select Partner",
                                modelValue: _ctx.bill.entity_id,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.bill.entity_id) = $event)),
                                filterable: "",
                                style: {"width":"100%"},
                                onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getEntityContract()))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (data) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: data.id,
                                      label: data.entity_short_name,
                                      value: data.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("[" + _toDisplayString(data.entity_short_name) + "]-" + _toDisplayString(data.entity_name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                              _hoisted_25,
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select Contract",
                                modelValue: _ctx.bill.entity_contract_id,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.bill.entity_contract_id) = $event)),
                                filterable: "",
                                style: {"width":"100%"},
                                onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getBillSequenceNo()))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contractInfos, (data) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: data.id,
                                      label: data.contract_name,
                                      value: data.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(data.contract_name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _hoisted_26,
                            _createElementVNode("div", _hoisted_27, [
                              _hoisted_28,
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                class: "form-control",
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.bill.bill_sequence_no) = $event)),
                                disabled: ""
                              }, null, 512), [
                                [_vModelText, _ctx.bill.bill_sequence_no]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_29, [
                              _hoisted_30,
                              _createVNode(_component_el_form_item, {
                                prop: "start_date",
                                class: "mb-0"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_date_picker, {
                                    modelValue: _ctx.bill.start_date,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.bill.start_date) = $event)),
                                    "value-format": "YYYY-MM-DD",
                                    format: "DD-MM-YYYY",
                                    style: {"width":"100%"},
                                    type: "date",
                                    name: "dob",
                                    disabled: ""
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showBatchList == true)
            ? (_openBlock(), _createElementBlock("div", { key: _ctx.claimBillBatchkey }, [
                _createElementVNode("h4", _hoisted_31, " Eligible Batches for Enrollment Bill Claim(Total Batch Found : " + _toDisplayString(_ctx.BatchList.length) + ") ", 1),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("table", _hoisted_38, [
                              _hoisted_39,
                              _createElementVNode("tbody", _hoisted_40, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.BatchList, (info, idx) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: idx,
                                    style: {"border-bottom":"1px solid\r\n                                    rgba(29, 182, 140, 0.51) !important"}
                                  }, [
                                    _createElementVNode("td", _hoisted_41, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        class: "form-check-input rounded-0",
                                        checked: "",
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedBatch) = $event)),
                                        value: info.id
                                      }, null, 8, _hoisted_42), [
                                        [_vModelCheckbox, _ctx.selectedBatch]
                                      ])
                                    ]),
                                    _createElementVNode("td", _hoisted_43, _toDisplayString(idx + 1), 1),
                                    _createElementVNode("td", _hoisted_44, _toDisplayString(info?.institute_info?.institute_name) + " ( " + _toDisplayString(info?.institute_info?.short_name) + " ) ", 1),
                                    _createElementVNode("td", _hoisted_45, _toDisplayString(info?.course_info?.course_name) + " | " + _toDisplayString(info?.course_info?.month) + " | " + _toDisplayString(info?.course_info?.hour) + " | " + _toDisplayString(info?.course_info?.unit_cost_total), 1),
                                    _createElementVNode("td", _hoisted_46, _toDisplayString(info?.batch_sequence_number), 1),
                                    _createElementVNode("td", _hoisted_47, _toDisplayString(info?.batch_training_summery?.t_enrolled), 1)
                                  ]))
                                }), 128))
                              ])
                            ]),
                            (_ctx.BatchList.length > 0)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                                  class: "btn btn-success p-3",
                                  style: {"padding-top":"8px !important","padding-bottom":"8px !important"},
                                  type: "submit",
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.addAllToClaim()))
                                }, [
                                  (!_ctx.loading)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_49, [
                                        _createTextVNode(" Send To Claim "),
                                        _createElementVNode("span", _hoisted_50, [
                                          _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.loading)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_51, [
                                        _createTextVNode(" Please wait... "),
                                        _hoisted_52
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 8, _hoisted_48))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showBillList == true || _ctx.billList.length > 0)
            ? (_openBlock(), _createElementBlock("div", { key: _ctx.claimBillkey }, [
                _createElementVNode("h3", _hoisted_53, " Selected Batches for Enrollment Bill Claim (Total Batch Found : " + _toDisplayString(_ctx.billList.length) + ") ", 1),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("table", _hoisted_59, [
                            _hoisted_60,
                            _createElementVNode("tbody", _hoisted_61, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billList, (data, index) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: index,
                                  style: {"border-bottom":"1px solid\r\n                                  rgba(29, 182, 140, 0.51) !important"}
                                }, [
                                  _createElementVNode("td", _hoisted_62, [
                                    _createElementVNode("button", {
                                      onClick: ($event: any) => (_ctx.Delete(data.id)),
                                      class: "btn btn-icon btn-bg-danger btn-active-color-primary btn-sm"
                                    }, _hoisted_65, 8, _hoisted_63)
                                  ]),
                                  _createElementVNode("td", _hoisted_66, _toDisplayString(index + 1), 1),
                                  _createElementVNode("td", _hoisted_67, _toDisplayString(data?.institute_info?.institute_name), 1),
                                  _createElementVNode("td", _hoisted_68, _toDisplayString(data?.course_info?.course_name) + " | " + _toDisplayString(data?.course_info?.month) + " | " + _toDisplayString(data?.course_info?.hour) + " | " + _toDisplayString(data?.course_info?.total_course_cost), 1),
                                  _createElementVNode("td", _hoisted_69, _toDisplayString(data?.batch_info?.batch_sequence_number), 1),
                                  _createElementVNode("td", _hoisted_70, _toDisplayString(data.trainee_count), 1),
                                  _createElementVNode("td", _hoisted_71, _toDisplayString(data.unit_cost.toFixed(2)), 1),
                                  _createElementVNode("td", _hoisted_72, _toDisplayString(data.pay_percentage), 1),
                                  _createElementVNode("td", _hoisted_73, _toDisplayString(Number(data.fee_per_trainee).toLocaleString()), 1),
                                  _createElementVNode("td", _hoisted_74, _toDisplayString(Number(data.bill_amount).toLocaleString()), 1),
                                  _createElementVNode("td", _hoisted_75, _toDisplayString(data.bill_no), 1),
                                  _createElementVNode("td", _hoisted_76, _toDisplayString(data?.bill_date
                                    ? _ctx.moment(data?.bill_date).format(
                                        'DD-MM-YYYY'
                                      )
                                    : data?.bill_date), 1)
                                ]))
                              }), 128))
                            ]),
                            _createElementVNode("tfoot", null, [
                              _createElementVNode("tr", _hoisted_77, [
                                _hoisted_78,
                                _hoisted_79,
                                _hoisted_80,
                                _hoisted_81,
                                _createElementVNode("th", _hoisted_82, _toDisplayString(_ctx.billList.length), 1),
                                _createElementVNode("th", _hoisted_83, _toDisplayString(Number(this.tolatTrainee).toLocaleString()), 1),
                                _hoisted_84,
                                _hoisted_85,
                                _hoisted_86,
                                _createElementVNode("th", _hoisted_87, _toDisplayString(Number(this.tolatBillAmount).toLocaleString()), 1),
                                _hoisted_88,
                                _hoisted_89
                              ]),
                              _createElementVNode("tr", _hoisted_90, [
                                _hoisted_91,
                                _createElementVNode("th", _hoisted_92, _toDisplayString(Number(this.tolatBillAmount).toLocaleString()), 1),
                                _hoisted_93,
                                _hoisted_94
                              ]),
                              _createElementVNode("tr", _hoisted_95, [
                                _hoisted_96,
                                _createElementVNode("th", _hoisted_97, _toDisplayString(Number(this.contributionPay).toLocaleString()) + "% ", 1),
                                _hoisted_98,
                                _hoisted_99
                              ]),
                              _createElementVNode("tr", _hoisted_100, [
                                _hoisted_101,
                                _createElementVNode("th", _hoisted_102, _toDisplayString(Number(
                                  this.totalContributionAmount
                                ).toLocaleString()), 1),
                                _hoisted_103,
                                _hoisted_104
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_105,
                                _createElementVNode("th", _hoisted_106, _toDisplayString(Number(this.totalPayableAmount).toLocaleString()), 1),
                                _hoisted_107,
                                _hoisted_108
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _hoisted_109,
                _createElementVNode("button", {
                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                  class: "btn btn-success ml-3 p-3",
                  style: {"padding-top":"8px !important","padding-bottom":"8px !important"},
                  type: "submit",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.confirmSubmitBill()))
                }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_111, [
                        _createTextVNode(" Submit Bill "),
                        _createElementVNode("span", _hoisted_112, [
                          _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_113, [
                        _createTextVNode(" Please wait... "),
                        _hoisted_114
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_110)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ])), [
    [_directive_loading, _ctx.load]
  ])
}